// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "ins.diffins,ins.diffmod,ins.mod{background-color:#b0ff6b;text-decoration:none}del.diffdel,del.diffmod,del.mod{background-color:#ff8987;text-decoration:none}", ""]);
// Exports
module.exports = exports;
